import React from "react";
import { Link } from "react-router-dom";
import { FaRupeeSign, FaCheckCircle, FaDownload, FaArrowRight } from "react-icons/fa";

const FeeStructurePage = () => {
  const courses = [
    {
      name: "GNM",
      duration: "3 Years",
      tutionFee: "90,000",
      hostelFee: "5500 Monthly",
      totalFee: "90,000",
      color: "green"
    },
    {
      name: "B.Sc. Nursing",
      duration: "4 Years",
      tutionFee: "110,000",
       hostelFee: "5500 Monthly",
      totalFee: "110,000",
      color: "blue"
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
              Fee Structure 2025-26
            </span>
          </h1>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Affordable education with scholarship opportunities for meritorious students
          </p>
        </div>
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-green-600 p-6 text-white">
            <h2 className="text-2xl font-bold">Course-wise Fee Details (Per Year)</h2>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Course</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Duration</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Tuition Fee (₹)</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Hostel Fee (₹)</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Total (₹)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {courses.map((course, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-semibold text-gray-800">{course.name}</td>
                    <td className="px-6 py-4 text-gray-600">{course.duration}</td>
                    <td className="px-6 py-4 text-gray-600">₹{course.tutionFee}</td>
                    <td className="px-6 py-4 text-gray-600">₹{course.hostelFee}</td>
                    <td className="px-6 py-4 font-semibold text-gray-800">₹{course.totalFee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="bg-white p-6 rounded-2xl shadow-lg">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Scholarship Opportunities</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <FaCheckCircle className="text-green-600 mt-1" />
                <div>
                  <p className="font-semibold">Merit Scholarship</p>
                  <p className="text-sm text-gray-600">Up to 50% for students with 90%+ in 10+2</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <FaCheckCircle className="text-blue-600 mt-1" />
                <div>
                  <p className="font-semibold">Sports Quota</p>
                  <p className="text-sm text-gray-600">Up to 25% for state/national level players</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <FaCheckCircle className="text-green-600 mt-1" />
                <div>
                  <p className="font-semibold">Single Girl Child</p>
                  <p className="text-sm text-gray-600">15% concession for single girl child</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Payment Options</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-50 p-4 rounded-xl text-center">
              <p className="font-semibold text-gray-800">Annual Payment</p>
              <p className="text-sm text-gray-600">Pay full fees at once</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-xl text-center">
              <p className="font-semibold text-gray-800">Semester Payment</p>
              <p className="text-sm text-gray-600">Two installments per year</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-xl text-center">
              <p className="font-semibold text-gray-800">Education Loan</p>
              <p className="text-sm text-gray-600">Tie-up with leading banks</p>
            </div>
          </div>
        </div>
        <div className="text-center">
          <button className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-green-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300 shadow-lg">
            <FaDownload /> Download Complete Fee Structure
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeeStructurePage;